<template>
  <div class="hero-container">
    <div
      class="hero-background"
      :style="`background-image: url(${heroData ? heroImage : ''}); transform: translateY(${heroPos}%)`"
    >
      <video
        v-if="heroData.type == 'video'"
        id="heroVideo"
        :src="heroData ? heroVideo : ''"
        autoplay
        loop
        muted
        playsinline
      ></video>
    </div>
    <div class="overlay" :class="{ hidden: currentHeroSegment == 1 }"></div>
    <div class="hero-segment scroll-target">
      <div class="hero-text">
        <h1 v-html="title"></h1>
      </div>
      <h2 class="author">{{ author }}</h2>
    </div>
    <div class="hero-segment scroll-target clear"></div>
    <div
      v-for="(segment, index) in copySegments"
      class="hero-segment scroll-target"
      :key="`hero-segment-${index}`"
    >
      <p class="intro-text">{{ segment.value }}</p>
    </div>
  </div>
</template>

<script>
// import VueScrollMagic from 'vue-scrollmagic'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    author: {
      type: String,
      default: ''
    },
    heroData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      currentHeroSegment: 0,
      scrollPosition: 0,
      portraitAspect: false
    }
  },
  computed: {
    heroPos () {
      const index = (this.scrollPosition / window.innerHeight) - 1
      const interval = 20.0 / this.scrollTargets.length
      return index * interval * -1
    },
    heroImage () {
      if (this.portraitAspect && this.heroData.heroMobile) {
        return this.heroData.heroMobile
      } else {
        return this.heroData.heroDesktop
      }
    },
    heroVideo () {
        return this.portraitAspect && this.heroData.heroMobile ? this.heroData.heroMobile : this.heroData.heroDesktop
    },
    copySegments () {
      if (this.heroData && this.heroData.copySegments) {
        return this.heroData.copySegments
      } else {
        return []
      }
    },
    scrollTargets () {
      return document.getElementsByClassName('scroll-target') || []
    }
  },
  mounted () {
    this.checkAspect()
  },
  methods: {
    checkAspect () {
      if (window.innerWidth <= window.innerHeight) {
        this.portraitAspect = true
      } else {
        this.portraitAspect = false
      }
    },
    handleScroll () {
      this.scrollPosition = window.scrollY
      this.scrollTargets.forEach((target, index) => {
        const top = window.innerHeight * index
        let delta = Math.abs(this.scrollPosition - top)
        if (delta >= window.innerHeight) {
          delta = window.innerHeight
        }

        const percent = 1 - (delta / window.innerHeight)
        // console.log(`${index}: ${percent}`)
        if (percent > 0.66) {
          target.classList.add('shown')
          this.currentHeroSegment = index
        } else {
          target.classList.remove('shown')
        }
        if (index == 0) {
          target.setAttribute('style', `opacity: ${percent}`)
        }
      })
    },
    handleResize () {
      this.checkAspect()
    },
    doneScrolling () {
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    window.onresize = this.handleResize
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_fonts';
@import '@/assets/style/_articles';
@import '@/assets/style/_variables';

.hero-container {
  @include bg-cover-center;
  position: relative;
  overflow: hidden;
  background-attachment: fixed;
  color: white;

  .hero-segment {
    position: relative;
    height: 100vh;
    text-align: center;
    box-sizing: border-box;
    // border: solid 1px red;

    &.shown .intro-text {
      opacity: 1;
      transition: .3s all;
    }

    .intro-text {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      
      width: 100%;
      max-width: $image-max-width;
      padding: $space-l-article;

      opacity: 0;

      font-size: $font-size-article-ml;
      line-height: 1.2em;

      transition: .3s all;

      @include media($bp-tablet) {
        font-size: $font-size-article-m;
      }
      @include media($bp-phone-l) {
        padding: $space-m-article;
        font-size: $font-size-article-s;
        line-height: 1.5em;
      }
    }
  }

  .overlay {
    @include fill-parent;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
    transition: .5s all;

    &.hidden {
      opacity: 0;
      transition: .5s all;
    }
  }

  .hero-background {
    @include bg-cover-center;
    position: fixed;
    top: -15vh;
    left: 0;
    width: 100%;
    height: 130vh;
    transform: translateY(5%);

    video {
      @include center-in-parent;
      min-width: 100%;
      min-height: 100%;
      max-height: 100vw;
    }
  }

  .hero-text {
    @include center-in-parent;
    padding: $space-l-article;
    width: 100%;

    @include media($bp-desktop-s) {
      padding: $space-m-article;
    }

    @include media($bp-tablet) {
      padding: $space-xs-article;
    }

    h1 {
      text-transform: uppercase;
      line-height: 1.25em;

      @include media($bp-desktop-s) {
        font-size: 60px;
      }

      @include media($bp-tablet) {
        font-size: 38px;
      }

      @include media($bp-phone-l) {
        font-size: 30px;
      }
    }
  }

  .author {
    @include center-in-parent;
    top: 75%;
    width: 100%;
  }
}
</style>
